import React from "react"

const VARIANT_MAP = {
    h1: "text-3xl lg:text-4xl font-bold mb-4", // text-3xl je fallback pro mobil, lg:text-4xl od 1024px+
    h2: "text-2xl sm:text-3xl font-semibold mb-3", // text-2xl mobil, sm:text-3xl od 640px+
    h3: "text-2xl sm:text-xl font-semibold mb-2",
    h4: "text-xl sm:text-lg font-medium mb-1",
    h5: "text-lg sm:text-md font-medium mb-0.5",
    h6: "text-base font-medium mb-0.5",
    "entity_team": "text-xl sm:text-lg lg:text-xl font-bold"
}

const COLOR_MAP = {
    black: "text-black",
    white: "text-white",
    main: "text-main",
    second: "text-second",
    gray: "text-gray-600",
    gray700: "text-gray-700",
    gray800: "text-gray-800",
    gray900: "text-gray-900",
}

const TAG_MAP = {
    h0: "h1",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
}

export default function Heading({ variant = "h1", children, color = "black" }) {
    const Tag = TAG_MAP[variant] || "h1"
    const variantClass = VARIANT_MAP[variant] || VARIANT_MAP.h1
    const colorClass = COLOR_MAP[color] || COLOR_MAP.black
    const className = `${variantClass} ${colorClass}`

    return (
        <Tag className={className}>
            {children}
        </Tag>
    )
}